<template>
  <h1 class="heading" contenteditable="true" @blur="handleInput" v-text="inputText" ></h1>
  <!-- <h1 class="heading" contenteditable="true" @input="handleInput" v-text="test"> {{inputText}}</h1> -->
    
</template>

<script>
export default {
    name: 'creature-heading',
    props: {
      text: String
    },
    data:function(){
      return{
        inputText : this.text
      }
    },
    methods:{
        handleInput:function(e){
            this.inputText = e.target.innerText;
        }
    }
}
</script>


<style >
  .heading:hover{
    background-color: white;
  }

  .heading{
    font-family: 'Libre Baskerville', 'Lora', 'Calisto MT',
                 'Bookman Old Style', Bookman, 'Goudy Old Style',
                 Garamond, 'Hoefler Text', 'Bitstream Charter',
                 Georgia, serif;
    color: #7A200D;
    font-weight: 700;
    margin: 0px;
    font-size: 23px;
    letter-spacing: 1px;
    font-variant: small-caps;
    display: table;
  }
</style>